import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70882d76"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "completion-state"
}
const _hoisted_2 = { class: "completion-icon-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "completion-title" }, "상담신청이 완료되었습니다!", -1))
const _hoisted_4 = { class: "completion-message" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "completion-main-text" }, " 담당자를 배정하여 빠른 시일 내에 연락드리도록 하겠습니다. ", -1))
const _hoisted_6 = { class: "completion-info" }
const _hoisted_7 = { class: "info-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "영업일 기준 1-2일 내 연락 예정", -1))
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "연락처: 1833-7489", -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "inquiry-title" }, "상담신청", -1))
const _hoisted_13 = { class: "form-section" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "section-inquiry-title" }, "기본 정보", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*", -1))
const _hoisted_17 = { class: "form-section" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "section-inquiry-title" }, "연락처 정보", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*", -1))
const _hoisted_22 = { class: "form-section" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "section-inquiry-title" }, "문의 내용", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*", -1))
const _hoisted_25 = { class: "form-section" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirm-dialog-title" }, "상담신청 확인", -1))
const _hoisted_27 = { class: "confirm-message" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "confirm-main-text" }, " 입력하신 정보로 상담신청을 진행하시겠습니까? ", -1))
const _hoisted_29 = { class: "confirm-warning" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "warning-text" }, " 입력하신 정보가 유효하지 않을 경우 상담문의가 자동 취소될 수 있습니다. ", -1))

import { ref, reactive } from 'vue';
import { useStore } from 'vuex';
import policyMent from './policyMent.vue';
import axios from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'InquiryFormEmbed',
  setup(__props) {

const store = useStore();

const compGubuns = [
  '요양시설',
  '주간보호센터',
  '재가센터',
  '의료기관',
  '사회복지시설',
  '기타'
];

const form = reactive({
  serviceConsult: true,
  groupPurchase: false,
  compName: '',
  compGubun: null,
  compSize: '',
  name: '',
  position: '',
  phone: '',
  email: '',
  memo: '',
  policy: false
});

// 유효성 검사 규칙
const rules = {
  required: (value: any) => !!value || '필수 입력 항목입니다.',
  email: (value: string) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(value) || '올바른 이메일 형식을 입력해주세요.';
  },
  phone: (value: string) => {
    const pattern = /^01[0-9]-\d{4}-\d{4}$/;
    return pattern.test(value) || '올바른 휴대폰 번호 형식을 입력해주세요. (010-0000-0000)';
  }
};

const loading = ref(false);
const formRef = ref();
const confirmDialog = ref(false);
const isCompleted = ref(false);

const formPolicyTrue = () => {
  form.policy = true;
};

const formPolicyFalse = () => {
  form.policy = false;
};

const resetForm = () => {
  Object.assign(form, {
    serviceConsult: true,
    groupPurchase: false,
    compName: '',
    compGubun: null,
    compSize: '',
    name: '',
    position: '',
    phone: '',
    email: '',
    memo: '',
    policy: false
  });
  if (formRef.value) {
    formRef.value.resetValidation();
  }
};

const resetToNewInquiry = () => {
  isCompleted.value = false;
  resetForm();
};

const registInquiry = async () => {
  // 폼 유효성 검사
  const { valid } = await formRef.value.validate();
  if (!valid) {
    store.commit('showSnackbar', {
      text: "입력 정보를 확인해주세요.",
      color: "error"
    });
    return;
  }

  // 상담 유형 선택 확인
  if (!form.serviceConsult && !form.groupPurchase) {
    store.commit('showSnackbar', {
      text: "상담 유형을 선택해주세요.",
      color: "error"
    });
    return;
  }

  // 개인정보처리방침 동의 확인
  if (!form.policy) {
    store.commit('showSnackbar', {
      text: "개인정보처리방침에 동의해주세요.",
      color: "error"
    });
    return;
  }

  // 확인 다이얼로그 표시
  confirmDialog.value = true;
};

const submitInquiry = async () => {
  try {
    loading.value = true;
    confirmDialog.value = false;
    
    const response = await axios.post('/api/registInquiry', { form: form });
    const result = response.data;
    
    if (result.success === true) {
      // 성공 시 완료 상태로 변경 (스낵바는 표시하지 않음)
      isCompleted.value = true;
    } else {
      store.commit('showSnackbar', {
        text: "상담문의 신청이 불가합니다.",
        color: "error"
      });
    }
  } catch (error) {
    store.commit('showSnackbar', {
      text: "상담문의 신청을 처리할 수 없습니다.",
      color: "error"
    });
    console.error(error);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "inquiry-card",
    elevation: "2"
  }, {
    default: _withCtx(() => [
      (isCompleted.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_card_title, { class: "completion-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-check-circle",
                    color: "success",
                    size: "48"
                  })
                ]),
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "completion-content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-clock-outline",
                        color: "primary",
                        size: "20",
                        class: "me-2"
                      }),
                      _hoisted_8
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-phone",
                        color: "primary",
                        size: "20",
                        class: "me-2"
                      }),
                      _hoisted_10
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "completion-actions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "outlined",
                  onClick: resetToNewInquiry,
                  class: "new-inquiry-btn",
                  size: "large",
                  block: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 새로운 상담신청 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_v_card_title, { class: "inquiry-header" }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "inquiry-content" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  ref_key: "formRef",
                  ref: formRef,
                  class: "inquiry-form"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: form.compName,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.compName) = $event)),
                                variant: "outlined",
                                maxlength: "50",
                                "hide-details": "auto",
                                rules: [rules.required],
                                color: "primary"
                              }, {
                                label: _withCtx(() => [
                                  _createTextVNode(" 기관명 "),
                                  _hoisted_15
                                ]),
                                _: 1
                              }, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                modelValue: form.compGubun,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.compGubun) = $event)),
                                variant: "outlined",
                                items: compGubuns,
                                "hide-details": "auto",
                                rules: [rules.required],
                                color: "primary"
                              }, {
                                label: _withCtx(() => [
                                  _createTextVNode(" 사업구분 "),
                                  _hoisted_16
                                ]),
                                _: 1
                              }, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: form.compSize,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.compSize) = $event)),
                                label: "기관 규모 (직원 수)",
                                variant: "outlined",
                                type: "number",
                                "hide-details": "auto",
                                color: "primary",
                                placeholder: "예: 50명"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: form.name,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.name) = $event)),
                                variant: "outlined",
                                maxlength: "20",
                                "hide-details": "auto",
                                rules: [rules.required],
                                color: "primary"
                              }, {
                                label: _withCtx(() => [
                                  _createTextVNode(" 담당자명 "),
                                  _hoisted_19
                                ]),
                                _: 1
                              }, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: form.position,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.position) = $event)),
                                label: "직책",
                                variant: "outlined",
                                maxlength: "20",
                                "hide-details": "auto",
                                color: "primary",
                                placeholder: "예: 팀장, 과장"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: form.phone,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.phone) = $event)),
                                variant: "outlined",
                                maxlength: "13",
                                "hide-details": "auto",
                                rules: [rules.required, rules.phone],
                                color: "primary",
                                placeholder: "010-0000-0000"
                              }, {
                                label: _withCtx(() => [
                                  _createTextVNode(" 휴대폰 번호 "),
                                  _hoisted_20
                                ]),
                                _: 1
                              }, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: form.email,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.email) = $event)),
                                variant: "outlined",
                                maxlength: "50",
                                "hide-details": "auto",
                                rules: [rules.required, rules.email],
                                color: "primary",
                                placeholder: "example@company.com"
                              }, {
                                label: _withCtx(() => [
                                  _createTextVNode(" 이메일 "),
                                  _hoisted_21
                                ]),
                                _: 1
                              }, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createVNode(_component_v_textarea, {
                        modelValue: form.memo,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.memo) = $event)),
                        variant: "outlined",
                        rows: "4",
                        maxlength: "500",
                        "hide-details": "auto",
                        rules: [rules.required],
                        color: "primary",
                        counter: "",
                        placeholder: "도입을 고려하시는 서비스나 궁금한 점을 자세히 적어주세요."
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(" 문의사항을 상세히 작성해주세요 "),
                          _hoisted_24
                        ]),
                        _: 1
                      }, 8, ["modelValue", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(policyMent, {
                        onSuccess: _cache[8] || (_cache[8] = ($event: any) => (formPolicyTrue())),
                        onFalse: _cache[9] || (_cache[9] = ($event: any) => (formPolicyFalse()))
                      })
                    ])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "inquiry-actions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "elevated",
                  onClick: registInquiry,
                  class: "action-btn",
                  loading: loading.value,
                  size: "large",
                  block: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 상담신청 ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_overlay, {
              modelValue: loading.value,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((loading).value = $event)),
              contained: "",
              class: "align-center justify-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_circular, {
                  color: "primary",
                  indeterminate: "",
                  size: "64"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])),
      _createVNode(_component_v_dialog, {
        modelValue: confirmDialog.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((confirmDialog).value = $event)),
        "max-width": "500px",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "confirm-dialog-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "confirm-dialog-header" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-help-circle",
                    color: "orange",
                    size: "32",
                    class: "me-3"
                  }),
                  _hoisted_26
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "confirm-dialog-content" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-information",
                        color: "info",
                        size: "20",
                        class: "me-2"
                      }),
                      _hoisted_30
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "confirm-dialog-actions" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "outlined",
                    color: "grey",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (confirmDialog.value = false)),
                    class: "confirm-btn"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 취소 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "elevated",
                    onClick: submitInquiry,
                    class: "confirm-btn",
                    loading: loading.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 상담신청 ")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})